import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { Modal } from './modal.model';
import { WindowRef } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private modals$ = new BehaviorSubject<Modal[]>([]);
  private activeModal$ = new BehaviorSubject<Modal | undefined>(undefined);

  constructor(private winRef: WindowRef) {}

  create(modal: Modal) {
    const modals = this.getAllAsValue();
    const $body = this.winRef.document.querySelector('body');
    const isNotRepeated = !modals.find((m: Modal) => m.id === modal.id);

    isNotRepeated && this.addModal(modal);
    $body?.classList.add('overflow-hidden');
  }

  addModal(modal: Modal) {
    const modals = this.getAllAsValue();
    modals.push(modal);

    this.modals$.next(modals);
    this.activeModal$.next(modal);
  }

  skip() {
    const modals = this.modals$.getValue();
    const modal = modals[modals.length - 1];

    if (modal) {
      if (modal?.onSkip) {
        modal?.onSkip() && this.close();
      } else {
        this.close();
      }
    }
  }

  close(modalIDs?: string[]) {
    let modals = this.modals$.getValue();
    const $body = this.winRef.document.querySelector('body');

    if (modals.length) {
      if (modalIDs) {
        modals = modals.filter(modal => !modalIDs.includes(modal.id));
      } else {
        modals.pop();
      }

      this.modals$.next(modals);
      this.activeModal$.next(modals[modals.length - 1]);
    }

    modals.length === 0 && $body?.classList.remove('overflow-hidden');
  }

  updateTitle(modalID: string, title: string) {
    const modals = this.modals$.getValue();
    const modalIndex = modals.findIndex((modal: Modal) => modal.id === modalID);

    if (modalIndex !== -1) {
      modals[modalIndex].title = title;
      this.modals$.next(modals);
    }
  }

  getActiveModal(): Observable<Modal | undefined> {
    return this.activeModal$.asObservable();
  }

  getAll(): Observable<Modal[]> {
    return this.modals$.asObservable();
  }

  getAllAsValue(): Modal[] {
    return this.modals$.getValue();
  }

  getDataByModalID(modalID: string): Observable<any> {
    return this.getAll().pipe(map((modals: Modal[]) => modals.find(modal => modal.id === modalID)?.data || {}));
  }
}
